import { ORGANIZATION } from 'constants/common';
import { TObject } from 'utils/types';

import {
  IUser,
  IUserData,
  IUserForm,
  IUserFormattedData,
  IUserMerchantTerminalData,
  IUsersMerchant,
} from './types';

export const normalizeUsersMerchant = (
  data: IUserMerchantTerminalData,
): IUsersMerchant => {
  return {
    fullAccess: !!data?.fullAccess,
    id: (data?.id as number) || 0,
    merchantTerminals: data?.merchantTerminals?.map((terminal) => ({
      id: (terminal?.id as number) || 0,
      name: (terminal?.name as string) || '',
    })),
    name: (data?.name as string) || ORGANIZATION,
  };
};

export const normalizeUser = (data: IUserData): IUser => {
  return {
    created: (data?.created as string) || '',
    enabled: !!data?.enabled,
    firstName: (data?.firstName as string) || '',
    id: (data?.userId as string) || (data?.id as string) || '',
    lastName: (data?.lastName as string) || '',
    login: (data?.login as string) || '',
    phoneCountryCode: (data?.phoneCountryCode as string) || '',
    phoneNumber: (data?.phoneNumber as string) || '',
    roleNames: (data?.roleNames as string[]) || [],
    roleScope: {
      fullAccess: !!data?.roleScope?.fullAccess,
      merchants: data?.roleScope?.merchants?.map(normalizeUsersMerchant) || [],
    },
    twoFaEnabled: !!data?.twoFaEnabled,
    whitelistEnabled: !!data?.whitelistEnabled,
    whitelistIps: (data?.whitelistIps as string) || '',
  };
};

export const formatUserFormValues = (values: IUserForm): IUserFormattedData => {
  return {
    ...values,
    roleScope: {
      ...values.roleScope,
      merchants: values.roleScope.merchants.map(
        ({ merchantTerminals, name: _, ...merchant }) => ({
          ...merchant,
          merchantTerminals: merchant.fullAccess
            ? []
            : merchantTerminals.map((terminal) => terminal.id),
        }),
      ),
    },
  };
};

export const normalizeUsersList = (data: TObject) => {
  return {
    label: (data?.username as string) || '',
    value: (data?.id as number) || 0,
  };
};
